export default "<span data-bind=\"html: cell.text, css: className\"></span>";